export default Object.freeze({
  type: process.env.NODE_ENV === 'development' ? 'dev' : 'prod',
});
